import get from 'Utils/lodash.get';
import { isObject } from 'Utils/common';

export default function (file, type = 'full') {
  if (!isObject(file)) {
    return '';
  }
  return get(file, `${type}.url`, '');
}
